export default __webpack_public_path__ + "static/media/img1.399e2759.png";